import { AmrDataRequestTabsComponent } from './amr-data-request-tabs.component';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';

export const AmrDataRequestRequesterTabsComponent = () => {
    const { dataRequest, organizations } = useDataRequestContext();
    const { shouldHideReviewers } = useDataRequestPermissionsContext();
    const isDraft = dataRequest.status === DataRequestStatusEnum.Draft;
    const hideReviewers = shouldHideReviewers(dataRequest, organizations);
    const showPrintTab = !hideReviewers && !isDraft;

    return (
        <AmrDataRequestTabsComponent
            showRequestTab={isDraft}
            showPrintTab={showPrintTab}
            showRequestPrintTab={false} //admin only
            showStatusUpdateTab={false} //admin only
        />
    );
};
